// 主数据管理-->流向商业-->中英文
export const expiringQualificationLocale = {
    'zhCN': {
        public: {
            batchStartUsing: '批量启用',
            batchStopUsing: '批量停用',
            batchUpload: '批量上传',
            whetherDelete: '是否删除该临期资质？',
            whetherStart: '是否启用？',
            whetherStop: '是否停用？',
            startRecordRequired: '请选择需要启用的资质。',
            stopRecordRequired: '请选择需要停用的资质。',
            // 上传
            templateDownload: '临期资质导入模板下载'
        },
        expiringQualification: {
            addContractor: '新增联系人',
            updateContractor: '编辑联系人',
            distributorName: '流向商业名称',
            productType: '产品类型',
            shipper: '货主',
            licenseType: '证书类型',
            status: '状态',
            validTo: '到期时间',
            sapCode: 'SAPCode',
            phCode: 'PHCode',
            licenseNumber: 'SAP记录号码',
            externalLicenseNumber: '证照号',
            name: '收货方名称',
            creator: '创建人',
            createTime: '创建时间',
            finalEditor: '修改人',
            finalEditTime: '修改时间',
            expiringQualificationManagement: '临期资质',
            // 验证
            receiverIDRequired: '请选择流向商业名称',
            licenseNumberRequired: '请输入SAP记录号码',
            licenseNumberLengthError: 'SAP记录号码过长',
            externalLicenseNumberLengthError: '证照号过长',
            licenseTypeIDRequired: '请选择证书类型',
            productTypeIDRequired: '请选择产品类型',
            shipperIDRequired: '请选择货主',
            statusRequired: '请选择状态',
            validToRequired: '请选择到期时间',
            // 列名
            receiverContact: '联系人',
            // 上传
            importTime: '上传时间',
            importer: '上传人',
            importFile: '导入文件',
            totalCount: '总数',
            rightCount: '正确数',
            differentCount: '异常数',
            ignoreCount: '忽略数',
            repeatCount: '重复数',
            errorCount: '错误数',
            warningCount: '警告数',
            importAbnormalData: '错误数据地址',
            importWarningData: '警告数据地址'
        }
    },
    'enUS': {
        public: {
            batchStartUsing: 'Batch Start',
            batchStopUsing: 'Batch Stop',
            batchUpload: 'Batch Upload',
            whetherDelete: 'Is it necessary to delete the term qualification?',
            whetherStart: 'Is it enabled?',
            whetherStop: 'Is it stop?',
            startRecordRequired: 'Please select the qualifications that need to be enabled.',
            stopRecordRequired: 'Please select the qualifications that need to be stoped.',
            // 上传
            templateDownload: 'Import Template Download'
        },
        expiringQualification: {
            addContractor: 'Add Contractor',
            updateContractor: 'Edit Contractor',
            distributorName: 'Distributor Name',
            productType: 'Product Type',
            shipper: 'Shipper',
            licenseType: 'License Type',
            status: 'Status',
            validTo: 'Expire Date',
            sapCode: 'SAPCode',
            phCode: 'PHCode',
            licenseNumber: 'Number',
            creator: 'Creator',
            createTime: 'CreateTime',
            finalEditor: 'FinalEditor',
            finalEditTime: 'FinalEditTime',
            externalLicenseNumber: 'External License Number',
            name: 'Receiver Name',
            expiringQualificationManagement: 'Qualification',
            // 验证
            receiverIDRequired: 'Required',
            licenseNumberRequired: 'Required',
            licenseNumberLengthError: 'SAP code exceeds the max length.',
            externalLicenseNumberLengthError: 'Certificate number exceeds the max length.',
            licenseTypeIDRequired: 'Required',
            productTypeIDRequired: 'Required',
            shipperIDRequired: 'Required',
            statusRequired: 'Required',
            validToRequired: 'Required',
            // 列名
            receiverContact: 'Contractor',
            // 上传
            importTime: 'Import Time',
            importer: 'Import User',
            importFile: 'Import File',
            totalCount: 'Total',
            rightCount: 'Correct',
            differentCount: 'Error',
            ignoreCount: 'Ignore',
            repeatCount: 'Repeat',
            errorCount: 'Error',
            warningCount: 'Warning',
            importAbnormalData: 'Error Data',
            importWarningData: 'Warning Data'
        }
    }
}
export default expiringQualificationLocale



// WEBPACK FOOTER //
// ./src/locale/modules/expiringQualificationLocale.js